import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import { isHelixEnabled } from 'utils/helix';
import meetingsKeys from './queryKeys';
export function fetchMyUpcomingMeetings() {
  return _fetchMyUpcomingMeetings.apply(this, arguments);
}
function _fetchMyUpcomingMeetings() {
  _fetchMyUpcomingMeetings = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (isHelixEnabled) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return", {
            hasUpcomingMeeting: false
          });
        case 1:
          return _context.abrupt("return", api('get', '/api/me/meeting/upcoming', null));
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _fetchMyUpcomingMeetings.apply(this, arguments);
}
export function useFetchMyUpcomingMeetings() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    queryOptions = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useQuery = useQuery(_objectSpread(_objectSpread({
      queryKey: meetingsKeys.myUpcoming,
      queryFn: fetchMyUpcomingMeetings
    }, queryOptions), {}, {
      enabled: isHelixEnabled
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded);
  return _objectSpread({
    data: data
  }, result);
}
export default fetchMyUpcomingMeetings;